"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _memorycache = require("./memorycache");
var _locko = _interopRequireDefault(require("locko"));
function getCacheKey(requestArguments) {
  var resource = requestArguments[0];
  return "" + resource;
}
function getResponse(_x, _x2) {
  return _getResponse.apply(this, arguments);
}
function _getResponse() {
  _getResponse = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(cache, requestArguments) {
    var cacheKey, cachedValue, fetchResponse, newlyCachedData;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          cacheKey = getCacheKey(requestArguments);
          _context.next = 3;
          return cache.get(cacheKey);
        case 3:
          cachedValue = _context.sent;
          if (!cachedValue) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", cachedValue);
        case 6:
          _context.next = 8;
          return _locko.default.lock(cacheKey);
        case 8:
          _context.prev = 8;
          _context.next = 11;
          return cache.get(cacheKey);
        case 11:
          cachedValue = _context.sent;
          if (!cachedValue) {
            _context.next = 14;
            break;
          }
          return _context.abrupt("return", cachedValue);
        case 14:
          _context.next = 16;
          return fetch.apply(void 0, requestArguments);
        case 16:
          fetchResponse = _context.sent;
          _context.next = 19;
          return cache.set(cacheKey, fetchResponse.json());
        case 19:
          newlyCachedData = _context.sent;
          return _context.abrupt("return", newlyCachedData);
        case 21:
          _context.prev = 21;
          _locko.default.unlock(cacheKey);
          return _context.finish(21);
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[8,, 21, 24]]);
  }));
  return _getResponse.apply(this, arguments);
}
function createFetchWithCache(cache) {
  var fetchCache = function fetchCache() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return getResponse(cache, args);
  };
  fetchCache.withCache = createFetchWithCache;
  return fetchCache;
}
var fetchWithCache = createFetchWithCache(new _memorycache.MemoryCache());
var _default = exports.default = fetchWithCache;